module.exports = __webpack_public_path__ + "img/turquoise.00dbbe3d.png";